<template>
    <div>
        <!--Start Middle content-->
        <!--Start internal page banner section-->
        <section class="internal-page-banner-main col-12">
            <div class="container">
                <div class="row">
                    <div class="page-title">
                        <h1> Leadership Development 
                            <div class="col-12 col-sm-12 col-md-3 col-lg-2 pull-right">
                                <v-select  class="" v-model="categoryId"
                                           @change="changedValue"
                                           @input="changedCategoryFor()"
                                           name="categoryId"
                                           id="categoryId"
                                           label="text"
                                           :filterable="false"
                                           :options="categoryArr"
                                           @search="onSearchCategory"
                                           placeholder="Select Category">
                                    <template slot="no-options">
                                        Search Parent Category...
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.text }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.text }}
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </h1>
                    </div>
                </div>
            </div>
        </section>
        <!--End internal page banner section-->
        <div class="internal-page-main-section leadership-development-main col-12">
            <div class="container">
                <div class="row">
                    <!--<div class="select-development-box-main col-12 float-r">
                        <div class="row">
                            <p class="color-888888 heading-text-14 line-height-16 font-text-semi-medium-mont float-l pt-12 pr-20"> Select One Category: </p>
                            <v-select  class="leadership-category pull-right" v-model="categoryId"
                                       @change="changedValue"
                                       @input="changedCategoryFor()"
                                       name="categoryId"
                                       id="categoryId"
                                       label="text"
                                       :filterable="false"
                                       :options="categoryArr"
                                       @search="onSearchCategory"
                                       placeholder="Select Parent Category">
                                <template slot="no-options">
                                    Search Parent Category...
                                </template>
                                <template slot="option" slot-scope="option">
                                    <div class="d-center">
                                        {{ option.text }}
                                    </div>
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    <div class="selected d-center">
                                        {{ option.text }}
                                    </div>
                                </template>
                            </v-select>
                        </div>
                    </div>-->
                    <div class="bottom-listing-prog col-12 float-l mt-50">
                        <div class="row" id="VideoMainContainer">
                            <div class="">
                                <template v-for="(text, index) in leadershipList">
                                    <div class="bottom-listing-prog-des col-12 col-sm-12 col-md-6 col-lg-6 float-l"> <!--First video-->
                                        <!--<video v-if="text.video_path != ''" width="560" controls="controls" preload="metadata">-->
                                        <!--<source :src="text.video_path" type="video/mp4">-->
                                        <!--</video>-->

                                        <!--<video v-if="text.video_url != ''" width="560" controls="controls" preload="metadata">-->
                                        <!--<source :src="text.video_url" type="video/mp4">-->
                                        <!--</video>-->
                                        <template v-if="text.video_path != ''">
                                            <video width="560" controls="controls" preload="metadata">
                                                <source :src="text.video_path + '#t=0.5'" type="video/mp4">
                                            </video>
                                        </template>
                                        <template v-if="text.video_url != ''">
                                            <iframe :src="text.video_url" controls  height="292" allowfullscreen autostart='0'></iframe>
                                        </template>
                                        <h3 class="leading-title float-l width-full color-blue heading-text-20 line-height-24 font-text-semi-medium-mont pt-28"> {{text.video_title}} </h3>

                                        <!-- <p class="leading-date width-full float-l color-333333 heading-text-12 line-height-16 font-text-regular-mont"> July 11, 2018  </p>

                                         <p class="leaning-detail float-l color-333333 heading-text-14 line-height-20 font-text-regular-mont mt-30"> Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>

                                        <div class="view-btn-small-big width-full float-l mt-40">
                                             <a href="#" class="hvr-sweep-to-right-blue" target="_blank"> Read More </a>
                                       </div> -->
                                    </div>

                                    <template v-if="(index + 1) % 2 == 0">
                                        <div class="clearfix"></div>
                                    </template>
                                </template>

                                <!--<div class="bottom-listing-prog-des col-12 col-sm-6 col-md-6 col-lg-6 float-l"> 
                                    <video width="560" controls="controls" preload="metadata">
                                        <source src="/static/video/i9_training_and_2018_INS_laws.mp4#t=0.5" type="video/mp4">
                                    </video>

                                    <h3 class="leading-title float-l width-full color-blue heading-text-20 line-height-24 font-text-semi-medium-mont pt-28"> Webinar Videos: I9 Training </h3>
                                </div> 
                                <div class="bottom-listing-prog-des col-12 col-sm-6 col-md-6 col-lg-6 float-l"> 
                                    <video width="560" controls="controls" preload="metadata">
                                        <source src="/static/video/DiscriminationDiversity&Harrassment.mp4#t=0.5" type="video/mp4">
                                    </video>

                                    <h3 class="leading-title float-l width-full color-blue heading-text-20 line-height-24 font-text-semi-medium-mont pt-28"> Discrimination Diversity & Harrassment </h3>
                                </div> 

                                <div class="bottom-listing-prog-des col-12 col-sm-6 col-md-6 col-lg-6 float-l">
                                    <video width="560" controls="controls" preload="metadata">
                                        <source src="/static/video/HiringFiring&Performance.mp4#t=0.5" type="video/mp4">
                                    </video>

                                    <h3 class="leading-title float-l width-full color-blue heading-text-20 line-height-24 font-text-semi-medium-mont pt-28"> Hiring Firing & Performance </h3>
                                </div>

                                <div class="bottom-listing-prog-des col-12 col-sm-6 col-md-6 col-lg-6 float-l">
                                    <video width="560" controls="controls" preload="metadata">
                                        <source src="/static/video/LeaveofAbsencePaidSickLeave.mp4#t=0.5" type="video/mp4">
                                    </video>

                                    <h3 class="leading-title float-l width-full color-blue heading-text-20 line-height-24 font-text-semi-medium-mont pt-28"> Leave of Absence Paid Sick Leave </h3>
                                </div>

                                <div class="bottom-listing-prog-des col-12 col-sm-6 col-md-6 col-lg-6 float-l">
                                    <video width="560" controls="controls" preload="metadata">
                                        <source src="/static/video/Wage&hour.mp4#t=0.5" type="video/mp4">
                                    </video>

                                    <h3 class="leading-title float-l width-full color-blue heading-text-20 line-height-24 font-text-semi-medium-mont pt-28"> Wage & hour </h3>
                                </div>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--End Middle content-->
    </div>
</template>
<script>
    import Vue from "vue";
    import vSelect from 'vue-select';
    import SessioMixin from '../mixins/sessionmixin';
    import { HTTP } from '../http-common';
    import draggable from 'vuedraggable';
    var self;
    export default {
        name: 'Leadership_Development',
        components: {
            'v-select': vSelect,
            draggable,
        },
        mixins: [SessioMixin],
        data() {
            return {
                categoryId: '',
                categoryArr: [],
                categoryType: 'leadership',
                leadershipList: [],
            }
        },
        watch: {
            categoryId: function (categoryId) {
                self.getLeadershipDevelopment();
            }
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },
        mounted: function () {
            self.MenuClose();
            self.loadCategoryFirst();
            self.getBuildVersion();
        },

        methods: {
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            loadCategoryFirst() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        'type': self.categoryType,
                    }
                };
                HTTP.get("getcategory", config)
                        .then(function (response) {
                            self.categoryArr = [];
                            var addAll = {text: 'All', value: '0'};
                            self.categoryArr.push(addAll);
                            $.each(response.data.content, function (i) {
                                self.categoryArr.push(response.data.content[i]);
                            });
                            self.categoryId = addAll;
//                        self.categoryArr = response.data.content;
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            changedValue: function (value) {
                //console.log(value);
            },
            changedCategoryFor: function () {

            },
            onSearchCategory(search, loading) {
                if (search.length >= 2) {
                    if (typeof (loading) != "undefined") {
                        loading(true);
                    }
                    this.loadCategory(loading, search, this);
                }
            },
            loadCategory(loading, search, vm) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        'type': self.categoryType,
                        'search': search,
                    }

                };
                HTTP.get("getcategory", config)
                        .then(function (response) {
                            self.categoryArr = response.data.content;
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },

            getLeadershipDevelopment: function () {
                var fields = {
                    categoryId: self.categoryId.value,
                    categoryType: self.categoryType,
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post('getleadershipdevelopment/' + self.categoryId.value, fields, config).
                        then(response => {
                            self.leadershipList = [];
                            setTimeout(function () {
                                self.leadershipList = response.data.content;
                            }, 100);
                        })
                        .catch(function (err) {
                            self.leadershipList = [];
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/LeadershipDevelopment.vue